export default function BackgroundStyle({ children }) {
  return (
    <>
      <div className="w-full h-screen bg-[#F9F9F9]">
        {children}
      </div>
    </>
  );
}
